"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMHandle = void 0;
const memoizee_1 = __importDefault(require("memoizee"));
const CapableHandle_1 = require("./CapableHandle");
const capitalize_1 = __importDefault(require("./capitalize"));
const EMRole_1 = require("./EMRole");
const EMWarningFlag_1 = require("./EMWarningFlag");
const EM_LEAD_ROLES = new Set([
    EMRole_1.EMRole.EM_MANAGER,
    EMRole_1.EMRole.LEAD_EM,
    EMRole_1.EMRole.SENIOR_EM_MANAGER,
    EMRole_1.EMRole.DIRECTOR,
]);
class EMHandle {
    constructor(em) {
        this.emailSet = (0, memoizee_1.default)(() => new Set(this.emails || []));
        this.getEmailDomains = (0, memoizee_1.default)(() => (this.emails || []).reduce((domains, email) => {
            const domain = email.split("@")?.[1];
            if (domain) {
                domains.add(domain);
            }
            return domains;
        }, new Set()));
        this.getCapacityHandle = (0, memoizee_1.default)(() => new CapableHandle_1.CapableHandle(this));
        Object.assign(this, em);
    }
    getDisplayName() {
        return (this.firstName || "") + " " + (this.lastName || "");
    }
    isLead() {
        return !!this.role && EM_LEAD_ROLES.has(this.role);
    }
    getWarningFlags() {
        const flags = new Set();
        if (!this.isLead() && !this.lead) {
            flags.add(EMWarningFlag_1.EMWarningFlag.NO_LEAD);
        }
        if (!this.jiraAccountId) {
            flags.add(EMWarningFlag_1.EMWarningFlag.NO_JIRA_ACCOUNT_ID);
        }
        if (!this.hasRackspaceEmail()) {
            flags.add(EMWarningFlag_1.EMWarningFlag.NO_RACKSPACE_EMAIL);
        }
        if (!this.getEmailDomains().has("onica.com")) {
            flags.add(EMWarningFlag_1.EMWarningFlag.NO_ONICA_EMAIL);
        }
        return flags;
    }
    compare(other, flaggedFirst = true) {
        const flags1 = this.getWarningFlags().size;
        const flags2 = other.getWarningFlags().size;
        if (flaggedFirst && flags1 !== flags2) {
            return flags2 - flags1;
        }
        return this.getDisplayName().localeCompare(other.getDisplayName());
    }
    getEmails() {
        return this.emailSet();
    }
    hasEmail(email) {
        return this.emailSet().has(email);
    }
    hasRackspaceEmail() {
        return (this.getEmailDomains().has("rackspace") || !!this.getRackspaceEmail());
    }
    getJiraLabel() {
        if (this.jiraLabel) {
            return this.jiraLabel;
        }
        return (0, capitalize_1.default)(this.firstName) + (0, capitalize_1.default)(this.lastName);
    }
    getOnicaEmail() {
        return (this.emails || []).find((email) => email.endsWith("onica.com"));
    }
    getRackspaceEmail() {
        return (this.emails || []).find((email) => email.indexOf("rackspace") > -1);
    }
    isOffboarded(now = new Date()) {
        return this.getCapacityHandle().isOffboarded(now);
    }
}
exports.EMHandle = EMHandle;
//# sourceMappingURL=EMHandle.js.map